import React from 'react';
import {
  Button,
  Heading,
  Text,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModal,
} from '@televet/kibble-ui';
import { ChannelStatusFragment } from 'shared/types/graphql';
import { useIntegrationsProvider } from 'shared/providers/IntegrationsProvider';

interface IStatusChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  statusName: string;
  onChangeStatus: (channelStatusObj?: ChannelStatusFragment) => void;
}

const StatusChangeModal = ({ isOpen, onClose, statusName, onChangeStatus }: IStatusChangeModalProps): JSX.Element => {
  const { primaryIntegrationName } = useIntegrationsProvider();

  return (
    <CModal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent p={6}>
        <CModalHeader p={0} h="60px">
          <Heading size="md">Cannot auto-export</Heading>
          <ModalCloseButton />
        </CModalHeader>
        <CModalBody p={0} mt={3}>
          <Text size="sm">
            {`The status "${statusName}" will not be able to automatically export your conversation as the client and/or
            patient(s) are not associated with ${primaryIntegrationName}.`}
          </Text>
        </CModalBody>
        <CModalFooter justifyContent="space-between" p={0} mt={6}>
          <Button variant="tertiary" onClick={onClose} size="md">
            Cancel
          </Button>
          <Button
            size="md"
            onClick={(): void => {
              onChangeStatus();
              onClose();
            }}
          >
            Change Status
          </Button>
        </CModalFooter>
      </ModalContent>
    </CModal>
  );
};

export default StatusChangeModal;
